<template>
  <div class="content">
    <div class="screen">
      <dl>
        <label>已选：</label>
        <div class="list">
          <li v-for="(s, i) in filters" :key="i" v-show="s.list.filter(i => i.selected).length > 0" :title="`${s.list.filter(i => i.selected).map(j => j.title).join('/')}`">
            <span>{{`${s.title}: ${s.list.filter(i => i.selected).map(j => j.title).join('/')}`}}</span>
            <i @click="cancelItemlist(s)"></i>
          </li>
          <span v-for="(s, i) in filters" :key="`s${i}`" v-show="s.list.filter(i => i.selected).length > 0">
            <span class="subList" v-for="(c, ci) in s.list" :key="ci" v-show="c.list && c.list.filter(i => i.selected).length > 0"
              :title="`${c.list && c.list.filter(i => i.selected).map(j => j.title).join('/')}`">
              <span>{{`${c.title}: ${c.list && c.list.filter(i => i.selected).map(j => j.title).join('/')}`}}</span>
              <i @click="cancelItemlist(c)"></i>
            </span>
          </span>
          <li v-if="timeDayData.list.filter(i => i.selected).length > 0" :title="`${timeDayData.list.filter(i => i.selected).map(j => j.title).join('/')}`">
            <span>{{`${timeDayData.title}: ${timeDayData.list.filter(i => i.selected).map(j => j.title).join('/')}`}}</span>
            <i @click="delTimeData()"></i>
          </li>
        </div>
        <button class="filter" @click="toggleFilter()">
          <img src="@assets/img/common/filter.svg" alt="filter">
          <span>{{showFilter ? '收起筛选' : '展开筛选'}}</span>
          <img :src="showFilter ? icons.upward : icons.downward" alt="down">
        </button>
      </dl>
      <div class="line" v-show="showFilter"></div>
      <div v-show="showFilter">
        <div class="mb10 public" v-for="(items, index) in filters" :key="index">
          <ul>
            <label>{{items.title}}</label>
            <li :class="{showSelect : items.expand}" :ref="`filter${index}`">
              <span :class="{active: item.selected}" v-for="(item, index) in items.list" :key="index" @click="selectItem(item, items)">{{item.title}}</span>
            </li>
            <li class="btn" v-if="items.list.length > 10">
              <button @click="showSelect(items, `filter${index}`)" class="down">
                <img :src="items.expand ? icons.upward : icons.downward" alt="icon">
              </button>
            </li>
          </ul>
          <ul v-for="(c, i) in items.list" v-show="c.selected && c.list && c.list.length > 0" :key="i">
            <label>{{c.title}}</label>
            <li :class="{showSelect : c.expand}" :ref="`filterson${index}_${i}`">
              <span :class="{active: ci.selected}" v-for="(ci, cd) in c.list" :key="cd" @click="selectItem(ci, c)">{{ci.title}}</span>
            </li>
            <li class="btn" v-if="c.list && c.list.length > 0 && calWidth('filterson'+index+'_'+i,c.list)">
              <button @click="showSelect(c, `filterson${index}_${i}`)" class="down">
                <img :src="c.expand ? icons.upward : icons.downward" alt="icon">
              </button>
            </li>
          </ul>
        </div>
        <ul v-show="hasDay">
          <label class="public">发布时间</label>
          <li v-show="!this.start && !this.end">
            <span :class="{active: d.key === day.key}" v-for="(d, i) in days" :key="i" @click="selectDay(d)">{{d.title}}</span>
          </li>
          <date-picker v-show="!this.day.key" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm>
          </date-picker>
        </ul>
      </div>
    </div>

    <div :class="{bg: true,empty: list.length == 0}">
      <div class="batch bt">
        <div class="left">
          <img :src="checkedAll ? checkerOn : checker" class="checker" alt="checker" @click="selectAllChecker()">
          <div class="bigBtn greenBtn" @click="approveChecks()">
            批量通过
          </div>
          <div class="bigBtn" @click="banChecks()">
            批量退回
          </div>
          <div class="fresh" @click="fresh()">刷新</div>
        </div>
        <div @click="$authTable" class="right">
          <i></i>
          <span>审核记录</span>
        </div>
        
      </div>

      <empty :mTop="50" class="empty" :msg="`暂无${$_syscfg.publish}数据`" v-if="list && list.length === 0 && !waiting" />
      <skeleton v-show="waiting"></skeleton>
      <div v-show="!waiting" class="items" v-for="(publish, i) in list" :key="i">
        <img v-if="publish.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
        <div class="item">
          <img :src="publish.checked? checkerOn :checker" class="checker" alt="checker" @click="selectChecker(publish)">
          <div class="pic" @click="viewMedia(publish)">
            <img @error="imgError(publish)" class="main" :src="publish.cover" alt="pic" v-if="publish.cover">
            <img class="main" src="@assets/img/common/default.png" alt="default" v-if="!publish.cover">
            <!-- <img v-if="publish.play_icon - 0 === 1 && publish.cover" class="play" src="@assets/img/index/play.svg" alt="play"> -->
          </div>
          <div class="article">
            <div class="title" @click="handleGo(publish)">
              <p @mouseenter="showHistory(i)" @mouseout="closeHistory(i)" class="tag" v-if="publish.status == '0' || publish.status == '1'">{{publish.status_name}}</p>
              <p class="words" :title="publish.title">
                {{publish.title}}
              </p>
              <img src="@assets/img/common/tips.svg" alt="change" v-if="publish.has_change - 0 === 1">
              <img src="@assets/img/common/new.svg" alt="new" v-if="publish.is_new - 0 === 1">
              <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="publish.has_img - 0 === 1">
              <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="publish.has_video - 0 === 1">
              <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="publish.has_sound - 0 === 1">
              <!-- todo 22 -->
              <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="publish.has_audit&&publish.has_audit==2" src="@assets/img/common/verify-fail.svg">
            </div>
            <p class="content">
              {{publish.content}}
            </p>
            <div v-show="publish.showHistory" :style="'width:'+errWidth+'px'" class="articleStatus-container">
              <div class="proceeding-container">
                <p :style="'width:'+itemprogress+'%'" class="proceeding"></p>
                <ul>
                  <li :class="{green: item.color == 'green', red: item.color == 'red'}" :style="'left:'+item.left+'%'" v-for="(item,index) in historyList.arr" :key="index">
                    <i></i>
                    <p>{{item.name}}</p>
                  </li>
                </ul>
              </div>

              <div v-if="false" class="time green">
                <i></i>
                <span>2019-03-24  12:30:00</span>
              </div>

              <div class="messageList">
                <div v-for="(item,index) in historyList.list" :key="index">
                  <p class="type">{{item.msg}}</p>
                  <p class="t">{{item.raw_add_time}}</p>
                  <p class="a">{{item.user_name}}</p>
                  <p :class="{s: true, red: item.color == 'red', green: item.color == 'green'}">{{item.type_name}}</p>
                </div>
              </div>
            </div>
            <div class="footline zz">
              <p class="mark">
                <img src="@assets/img/common/zz.svg" alt="time">
                <span>{{publish.user_name}}</span>
              </p>
              <p class="mark addTime">
                <img src="@assets/img/index/time.svg" alt="time">
                <span>{{publish.add_time}}</span>
              </p>
              <p v-if="publish.column" class="mark caiyong">
                <img src="@assets/img/index/platform.svg" alt="tv">
                <span>
                  {{publish.column}}
                </span>
              </p>
            </div>
          </div>
          <div class="handles">
            <div v-if="publish.has_view" class="handle s" @click="previewMedia(publish)">
              预览
            </div>
            <div class="handle s" @click="goEdit(publish.id)">
              编辑
            </div>
            <div class="handle greenBtn s" @click="upload(publish)">
              通过
            </div>
            <div class="handle s" @click="sendBack(publish.id)">
              退回
            </div>
          </div>
        </div>
      </div>
      <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
    </div>
  </div>
</template>

<script>
import pages from "@components/pages";
import common from "@common/common";
import { apis } from "@common/config";
import empty from "@components/empty";
import skeleton from "@components/skeleton";
import DatePicker from "vue2-datepicker";

export default {
  name: "checkInterviews",
  components: {
    pages,
    empty,
    DatePicker,
    skeleton
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function (n) {
        this.page.pageIndex = 1;

        this.start = common.stampToTime(n[0]);
        this.end = this.getDayEnd(n[1]);
        this.changeTime();
      }
    }
  },
  data() {
    return {
      errWidth: 584,
      waiting: true,
      hasDay: false,
      verifying: false,
      isXnew: this.$store.state.isXnew,
      page: {
        pageIndex: 1,
        pageCount: 0,
        pageSize: 10,
        total: 0
      },
      checkedAll: false,
      checker: require("@assets/img/interview/checker.svg"),
      checkerOn: require("@assets/img/interview/checkerOn.svg"),
      list: [],
      allSelected: false,
      select: false,
      backShow: false,
      showFilter: true,
      filters: [],
      expandedFilters: {}, // 用户记录已展开的类别，用于每次数据返回时保持状态
      filterOptions: {},
      days: [
        {
          title: "今天",
          key: 1
        },
        {
          title: "昨天",
          key: 2
        },
        {
          title: "前一周",
          key: 3
        }
      ],
      day: {},
      datePicker: "",
      start: "",
      end: "",
      searchOptions: {},
      sorts: [
        {
          title: "时间",
          key: "time",
          selected: true
        },
        {
          title: "被发送",
          key: "push_num",
          selected: false
        }
      ],
      pushBox: false,
      icons: {
        checker: require("@assets/img/interview/checker.svg"),
        checkerOn: require("@assets/img/interview/checkerOn.svg"),
        downward: require("@assets/img/common/xiala.svg"),
        upward: require("@assets/img/common/upward.svg")
      },
      selectedTag: "",
      timeDayData: {
        title: "发布时间",
        list: []
      },
      historyList: {},
      itemprogress: 0,
      interval: null
    };
  },
  methods: {
    calWidth(filter,list) {
      if(list.length > 0) {
        // console.log(12345,filter,this.$refs[filter])
        if(this.$refs[filter]){
          let width = this.$refs[filter][0].getBoundingClientRect().width;
          let w = 0
          if(this.$refs[filter][0].children.length > 0){
            for(let i = 0; i < this.$refs[filter][0].children.length; i++){
              w+=this.$refs[filter][0].children[i].getBoundingClientRect().width
            }
          }

          // console.log(w,width)

          if(w > width){
            return true
          }
          // console.log(width, w)
        }
      }
      
    },
    getDayEnd(s) {
      // 获取当天的结束时间
      if (!s) {
        return "";
      }
      const year = s.getFullYear();
      const month = common.doubleDigit(s.getMonth() + 1);
      const day = common.doubleDigit(s.getDate());

      return `${year}-${month}-${day} 23:59:59`;
    },
    delTimeData() {
      // 删除时间选择
      this.timeDayData = {
        title: "发布时间",
        list: []
      };

      if (this.start || this.end) {
        this.datePicker = "";
      } else {
        this.day = {};
        this.calculatefitlers();
      }
    },
    changeTime() {
      this.calculatefitlers();
    },
    selectDay(d) {
      this.page.pageIndex = 1;

      if (d.key === this.day.key) {
        this.day = {};
      } else {
        this.day = d;
      }

      this.calculatefitlers();
    },
    addTimeData(n) {
      const timeObj = {
        days: "",
        start: "",
        end: ""
      };

      const timeFilterObj = {
        title: "发布时间",
        list: []
      };

      if (this.day.key) {
        timeObj.days = this.day.key || "";

        const dayTitle = this.day.title;
        const dayObj = {
          title: dayTitle,
          selected: true
        };
        timeFilterObj.list.push(dayObj);
      }

      if (this.start || this.end) {
        timeObj.start = this.start;
        timeObj.end = this.end;

        const dayObj = {
          title: `${timeObj.start.split(" ")[0]}~${timeObj.end.split(" ")[0]}`,
          selected: true
        };
        timeFilterObj.list.push(dayObj);
      }

      this.timeDayData = timeFilterObj;
      Object.assign(this.filterOptions, timeObj);
    },
    toggleFilter() {
      // 切换筛选框
      this.showFilter = !this.showFilter;
    },
    switchSort(i) {
      // 切换筛选
      if (i.selected) return;

      this.sorts.forEach(s => {
        this.$set(s, "selected", false);
      });

      this.$set(i, "selected", true);
      this.filterOptions["sort_by"] = i.key;
      this.getList();
    },
    selectAll() {
      // 全选／反选 列表项
      const pushlist = this.list.filter(l => {
        if (l.has_push) {
          return l;
        }
      });

      this.allSelected = !this.allSelected;

      pushlist.forEach(i => {
        this.$set(i, "selected", this.allSelected);
      });

      if (pushlist.length !== this.page.pageSize) {
        let msg = "已选中有发送权限的条目";
        if (pushlist.length === 0) {
          msg = "暂无可发送的条目";
        }

        this.$toast(msg);
        this.allSelected = false;
      }
    },
    selectOne(i) {
      // 选择／反选 列表项
      if (!i.has_push) {
        this.$toast("无发送权限，无法选中");
        return;
      }

      this.$set(i, "selected", !i.selected);

      this.$nextTick(() => {
        if (!i.selected) {
          this.allSelected = false;
        }
      });
    },
    showSelect(i, key) {
      // 展开／关闭收起某类
      this.$set(i, "expand", !i.expand);

      this.$nextTick(() => {
        this.$set(this.expandedFilters, i.key, i.expand);

        if (!i.expand) {
          this.$refs[key][0].scrollTop = 0;
        }
      });
    },
    selectItem(i, l) {
      // 选择／反选 过滤项
      this.page.pageIndex = 1;

      this.$set(i, "selected", !i.selected);
      this.calculatefitlers();
    },
    cancelItemlist(l) {
      // 取消某类条件
      this.page.pageIndex = 1;

      l.list.forEach(i => {
        this.$set(i, "selected", false);
        i.list &&
          i.list.forEach(c => {
            this.$set(c, "selected", false);
          });
      });

      this.$nextTick(() => {
        this.calculatefitlers();
      });
    },
    calculatefitlers() {
      this.filters.forEach(i => {
        const selected1 = [] // 一级已选
        let selected2 = [] // 二级已选
        let key2 = ''
        i.list.forEach(c => {
          if (c.selected) {
            selected1.push(c.id || c.key)
          }else{
            if(c.list){
              c.list.forEach( s => {
                s.selected = false;
              })
            }
          }

          if (c.list) {
            const subSelected = []
            key2 = c.key
            c.list.forEach( s => {
              if (s.selected) {
                subSelected.push(s.id)
              }
            })
            selected2 = selected2.concat(subSelected)
          }
        })

        this.filterOptions[i.key] = selected1.join(',')
        if (key2) this.filterOptions[key2] = selected2.join(',')
      })

      this.addTimeData();
      this.getList();
    },
    fresh() {
      this.getList();
    },
    showHistory(i) {
      this.list[i].showHistory = true

      const info = {
        id: this.list[i].id
      };

      common.myFetch(apis.newMediaPlatformMyHistory, info).then(r => {
        if (r) {
          let arr = []
          for(let key in r.points){
            if(r.points[key].exist) {
              arr.push({
                name: r.points[key].desc,
                color: r.points[key].color
              })
            }
          }

          if(arr.length > 8){
            this.errWidth = arr.length * 73
          }else{
            this.errWidth = 584
          }

          if (arr.length > 2){
            let length = arr.length - 1
            let gap = 100 / length
            let init = 0
            let i = 0
            arr.forEach(el => {
              el.left = init * gap
              if(el.color == 'green'){
                i = init
              }
              init ++
            })
            arr[length].left = 98;
            this.itemprogress = i * gap
          }else if(arr.length == 2){
            arr[0].left = 0;
            arr[1].left = 98;
            if(arr[1].color == 'green'){
              this.itemprogress = 100
            }
          }else if(arr.length == 1){
            arr.push({
              name: '发布',
              color: 'white'
            })
            arr[0].left = 0;
            arr[1].left = 98;
            this.itemprogress = 0
          }

          r.arr = arr
          this.historyList = r
        }
      });
    },
    closeHistory(i) {
      this.list[i].showHistory = false
    },
    imgError(i) {
      i.img_url = require('@assets/img/common/default.png')
    },
    async goEdit(i) {
      let info = {
        id: i
      }

      common
      .myFetch(apis.checkPassAccess, {data: info, hideLoading: true}).then(r => {
        if (r) {
          if(r.data.length > 0){
            if(r.data[0].type == 'locked'){
              r.data[0].showIcon = false;
              r.data[0].title = '温馨提示';
              r.data[0].btn1 = '确定'
              this.$MediaPlatformNotifyAuth(r.data[0])
            }else if(r.data[0].type == 'authLocked'){
              r.data[0].showIcon = false;
              r.data[0].title = '温馨提示';
              r.data[0].btn1 = '确定'
              this.$MediaPlatformNotifyAuth(r.data[0])
            }else{
              this.$auditDialog({type: 'notice', title: '温馨提示', content1: r.data[0].msg, content2: '', btn1: '确定', btn2: ''})
            }
          }else{
            const newWindow = window.open();
            common.checkPageStatus(i, 2).then(r => {
              if (r) {
                newWindow.location.href = `${window.location.origin
                  }/editMediaPublish?d=${i}`;
              } else {
                newWindow.close();
              }
            });
          }
        }
      })
    },
    previewMedia(detail) {
      // console.log(detail)
      if(detail.platform_key == 'new_media_knews' || detail.platform_key == 'five_star_sports_cms'){
        this.$PreviewKnews(detail.id)
      }else if(detail.platform_key == 'bilibili'){
        this.$PreviewBili(detail.id)
      }else{
        detail.platformType = detail.platform_key
        this.$PreviewBox(detail)
      }
    },
    async goPublish(i) {
      if (!i) return;

      await this.$audit(i);
    },
    //点击图片弹框
    async viewMedia(item) {
      let list = await common.myFetch(apis.File_status, {
        subject_id: item.id,
        subject_type: 5
      })
      common.openMaterialBox(list, null, false);
    },
    //点击跳转链接
    handleGo(i) {
      const s = i.status;
      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);
      console.log(i)
      if (s == 0) {
        this.goEdit(i.id);
      } else {
        this.goDetail(i.id);
      }
    },
    goDetail(i) {
      common.jump(`/mediaPublishDetail?d=${i}&c=t`, true);
    },
    getList(keyWord) {
      // 获取列表数据
      this.waiting = true;
      const info = {
        pagesize: this.page.pageSize,
        page: this.page.pageIndex,
        search_option: "",
        key_words: "",
        status: ""
      };

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions);

      common.myFetch(apis.newMediaVerifylist, info).then(res => {
        if (res) {
          this.allSelected = false;
          res.list.forEach(el => {
            el.showHistory = false
          })
          this.list = res.list;

          res.params.list_search.forEach(i => {
            // 返回的数据添加已展开状态，保持列表状态
            i.expand = this.expandedFilters[i.key];
            i.list &&
              i.list.forEach(j => {
                j.expand = this.expandedFilters[j.key];
              });
          });

          res.params.list_search.forEach(el => {
            if(el.key == 'days'){
              this.hasDay = true
            }
          })

          this.filters = res.params.list_search.filter(
            i => i.key != "days" && i.key != "start" && i.key != "end"
          );


          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
          this.showCreate = res.has_add_role;

          this.$nextTick(() => {
            this.waiting = false;
          })
        }
      });
    },
    autoSelectTag() {
      // 自动选中标签（从详情页回来时）
      if (!this.selectedTag) return;

      const tags = this.filters.filter(i => i.key === "tag_id")[0].list;
      let tag = {};
      tags.forEach(i => {
        if (this.selectedTag === i.title) {
          tag = i;
        }
      });

      this.selectedTag = "";
      this.selectItem(tag);
    },
    generateSearchs(data) {
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };

      this.postSearch(filterData);
    },
    // 接收搜索框数据
    getSearch(d) {
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    // 发送搜索框数据
    postSearch(data) {
      this.$emit("filterData", data);
    },
    //选中
    selectChecker(i) {
      this.$set(i, "checked", !i.checked);
    },
    //全选
    selectAllChecker() {
      this.list.forEach(i => {
        this.$set(i, "checked", !this.checkedAll);
      });
      this.checkedAll = !this.checkedAll;
    },
    async handleInterviews(ids, status) {
      let msg = "确认通过吗？";
      if (status === 1) {
        msg = "确认退回吗？";
      }
      const c = await this.$confirm(msg);
      if (!c) return;
      if(this.verifying) return
      this.verifying = true

      if(status === 1){
        const statusInfo = {
          id: ids.join(",")
        };

        common.myFetch(apis.newMediaCheckstatus, statusInfo).then(data => {
          if (!data || !data.available) { this.verifying = false; return }
          if (data) {
            console.log(data)
            this.$Table({
              type: 'fail',
              data: data
            }).then(res => {
              console.log(res)
              if (!res) { this.verifying = false; return }
              let content = []
              res.forEach(el => {
                content.push({
                  id: el.id,
                  remark: el.content
                })
              })

              const info = {
                status: 1,
                content: JSON.stringify(content)
              }

              common.myFetch(apis.newMediaVerify, info).then(data => {
                this.verifying = false;
                if (data) {
                  this.checkedAll = false;
                  if(data.length == 0){
                    this.$toast('退回成功');
                  }
                  this.getList();
                }
              });
            })
          }
        });
      }else{
        let lockInfo = {
          id: ids.join(",")
        }

        common
        .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
        .then(r => {
            if (!r) { this.verifying = false; return }
            if (r) {
              let content = []
              ids.forEach(el => {
                content.push({
                  id: el
                })
              })

              const info = {
                status: 0,
                content: JSON.stringify(content)
              }

              common.myFetch(apis.newMediaVerify, info).then(data => {
                this.verifying = false;
                if (data) {
                  console.log(data)
                  if(data.length > 0){
                    this.$Table({
                      type: 'success',
                      data: data
                    })
                  }else{
                    this.$toast('操作成功');
                  }
                  this.checkedAll = false;
                  // this.$toast(data);
                  this.getList();
                }
              });
            }
        });
      }
    },
    async handleInterview(id, status) {
      let info = {
        id: id
      }

      common
      .myFetch(apis.checkPassAccess, {data: info, hideLoading: true})
      .then(async r =>  {
          if (r) {
            // console.log(r)
            if(r.data.length > 0){
              if(r.data[0].type == 'locked'){
                r.data[0].showIcon = false;
                r.data[0].title = '温馨提示';
                r.data[0].btn1 = '确定'
                this.$MediaPlatformNotifyAuth(r.data[0])
              }else if(r.data[0].type == 'authLocked'){
                r.data[0].showIcon = false;
                r.data[0].title = '温馨提示';
                r.data[0].btn1 = '确定'
                this.$MediaPlatformNotifyAuth(r.data[0])
              }else{
                this.$auditDialog({type: 'notice', title: '温馨提示', content1: r.data[0].msg, content2: '', btn1: '确定', btn2: ''})
              }
            }else{
              let msg = "确认通过吗？";
              let remark = "";
              if (status === 1) {
                msg = "确认退回吗？";
              }
              const c = await this.$confirm(msg);
              if (!c) return;
              if(this.verifying) return
              this.verifying = true

              if(status === 1) {
                const statusInfo = {
                  id: id
                };

                common.myFetch(apis.newMediaCheckstatus, statusInfo).then(data => {
                  if (!data || !data.unavailable) { this.verifying = false; return }
                  if (data) {
                    console.log(data)
                    if(data.unavailable.length > 0){
                      data.unavailable[0].showIcon = false;
                      data.unavailable[0].title = '温馨提示';
                      data.unavailable[0].btn1 = '确定'
                      this.$MediaPlatformNotifyAuth(data.unavailable[0])
                      this.verifying = false
                    }else{
                      let lockInfo = {
                        id: id
                      }
                      common
                      .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
                      .then(r => {
                          if (r) {
                              this.interval = setInterval(() => {
                                  lockInfo = {
                                    id: id
                                  }

                                  common
                                  .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
                                  .then(r => {
                                      if (r) {
                                          
                                      }
                                  });
                              }, 30000);
                          }
                      });
                      this.$Dialog({}).then((e) => {
                        console.log(e)
                        if(this.interval){
                          clearInterval(this.interval);
                        }
                        this.interval = null
                        if(!e) { this.verifying = false; return }
                        if(e){
                          let content = [{
                            id: id,
                            remark: e
                          }]

                          const info = {
                            status: 1,
                            content: JSON.stringify(content)
                          }

                          common.myFetch(apis.newMediaVerify, info).then(data => {
                            this.verifying = false;
                            if (data) {
                              this.getList();
                            }
                          });
                        }
                      })
                    }
                  }
                });
                // remark = await this.$Dialog({})
              }else{
                let lockInfo = {
                  id: id
                }

                common
                .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
                .then(r => {
                    if (!r) { this.verifying = false; return }
                    if (r) {
                      let content = [{
                        id: id
                      }]

                      content = JSON.stringify(content)

                      const info = {
                        content: content,
                        status: status
                      };

                      common.myFetch(apis.newMediaVerify, info).then(data => {
                        this.verifying = false;
                        if (data) {
                          if(data.length > 0){
                            data[0].showIcon = false;
                            data[0].title = '温馨提示';
                            data[0].btn1 = '确定'
                            this.$MediaPlatformNotifyAuth(data[0])
                          }else{
                            this.getList();
                          }
                        }
                      });
                    }
                });
              }
            }
          }
      });
    },
    allChecks() {
      const selected = [];
      this.list.forEach(i => {
        if (i["checked"]) {
          selected.push(i.id);
        }
      });

      return selected;
    },
    //通过
    upload(publish) {
      if(publish.is_last_audit == 1 && publish.platform_key == 'dy' && publish.has_dy_btn == 0){
        let info = {
          id: publish.id
        }

        common
        .myFetch(apis.checkPassAccess, {data: info, hideLoading: true})
        .then(r => {
            if (r) {
              if(r.data.length > 0){
                if(r.data[0].type == 'locked'){
                  r.data[0].showIcon = false;
                  r.data[0].title = '温馨提示';
                  r.data[0].btn1 = '确定'
                  this.$MediaPlatformNotifyAuth(r.data[0])
                }else if(r.data[0].type == 'authLocked'){
                  r.data[0].showIcon = false;
                  r.data[0].title = '温馨提示';
                  r.data[0].btn1 = '确定'
                  this.$MediaPlatformNotifyAuth(r.data[0])
                }else{
                  this.$auditDialog({type: 'notice', title: '温馨提示', content1: r.data[0].msg, content2: '', btn1: '确定', btn2: ''})
                }
              }else{
                this.$ConfirmDy({title: publish.title,column: publish.column}).then(res => {
                  if(res){
                    if(this.verifying) return
                    this.verifying = true
                    let lockInfo = {
                      id: publish.id
                    }

                    common
                    .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
                    .then(r => {
                        if (!r) { this.verifying = false; return }
                        if (r) {
                          let content = [{
                            id: publish.id
                          }]

                          content = JSON.stringify(content)

                          const info = {
                            content: content,
                            status: 0
                          };

                          common.myFetch(apis.newMediaVerify, info).then(data => {
                            this.verifying = false;
                            if (data) {
                              if(data.length > 0){
                                data[0].showIcon = false;
                                data[0].title = '温馨提示';
                                data[0].btn1 = '确定'
                                this.$MediaPlatformNotifyAuth(data[0])
                              }else{
                                this.getList();
                              }
                            }
                          });
                        }
                    });
                  }
                })
              }
            }
        });
      }else if(publish.is_last_audit == 1 && publish.platform_key != 'dy'){
        let info = {
          id: publish.id
        }

        common
        .myFetch(apis.checkPassAccess, {data: info, hideLoading: true})
        .then(r => {
            if (r) {
              if(r.data.length > 0){
                if(r.data[0].type == 'locked'){
                  r.data[0].showIcon = false;
                  r.data[0].title = '温馨提示';
                  r.data[0].btn1 = '确定'
                  this.$MediaPlatformNotifyAuth(r.data[0])
                }else if(r.data[0].type == 'authLocked'){
                  r.data[0].showIcon = false;
                  r.data[0].title = '温馨提示';
                  r.data[0].btn1 = '确定'
                  this.$MediaPlatformNotifyAuth(r.data[0])
                }else{
                  this.$auditDialog({type: 'notice', title: '温馨提示', content1: r.data[0].msg, content2: '', btn1: '确定', btn2: ''})
                }
              }else{
                this.$auditDialog({type: 'notice', title: '温馨提示', content1: '<span>'+publish.title+'</span>'+'将被推送至'+'<span>'+publish.column+'</span>', content2: '', btn1: '确定通过', btn2: '取消'}).then(res => {
                  if(res){
                    if(this.verifying) return
                    this.verifying = true
                    let lockInfo = {
                      id: publish.id
                    }

                    common
                    .myFetch(apis.newMediaLock, {data: lockInfo, hideLoading: true})
                    .then(r => {
                        if (!r) { this.verifying = false; return }
                        if (r) {
                          let content = [{
                            id: publish.id
                          }]

                          content = JSON.stringify(content)

                          const info = {
                            content: content,
                            status: 0
                          };

                          common.myFetch(apis.newMediaVerify, info).then(data => {
                            this.verifying = false;
                            if (data) {
                              if(data.length > 0){
                                data[0].showIcon = false;
                                data[0].title = '温馨提示';
                                data[0].btn1 = '确定'
                                this.$MediaPlatformNotifyAuth(data[0])
                              }else{
                                this.getList();
                              }
                            }
                          });
                        }
                    });
                  }
                })
              }
            }
        });
      }else{
        this.handleInterview(publish.id, 0);
      }
    },
    //退回
    sendBack(id) {
      this.handleInterview(id, 1);
    },
    //批量退回
    banChecks() {
      const ids = this.allChecks();
      console.log(ids)
      if(ids.length == 0){
        this.$toast('请选择稿件')
      }else{
        this.handleInterviews(ids, 1);
      }
    },
    //批量通过 
    approveChecks() {
      const ids = this.allChecks();
      console.log(ids)
      if(ids.length == 0){
        this.$toast('请选择稿件')
      }else{
        this.handleInterviews(ids, 0);
      }
      // newMediaCheckstatus
    }
  }, 
  destroy() {
    if(this.interval){
      clearInterval(this.interval);
    }
    this.interval = null
  },
  beforeDestroy() {
    this.$AiMessage(true)
  },
  mounted() {
    this.getList('noKeyWord');
    common.handleSocket(this.getList, "mediaPublishAuditRefresh");
    this.$AiMessage()
  }
};
</script>

<style lang="less" src="@assets/css/mediaPublish/publishAudit.less" scoped>
</style>
<style lang="less" src="@assets/css/mediaPublish/statusDialog.less" scoped>
</style>
<style lang="less" scoped>
@import "../../assets/css/global.less";
  //筛选
  .screen {
    background: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    padding: 20px 30px;
    margin-bottom: 29px;
    .line {
      height: 1px;
      width: 100%;
      background-color: @border;
      margin: 10px 0 20px;
    }
    dl {
      display: flex;
      color: @sub;
      font-size: 13px;
      
      label {
        width: 52px;
        height: 30px;
        line-height: 30px;
        margin-right: 10px;
        flex-shrink: 0;
        font-weight: bold;
      }
      .filter {
        border: 1px solid @dc;
        border-radius: 2px;
        width: 120px;
        height: 28px;
        font-size: 14px;
        color: @sub;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        background-color: rgba(185, 195, 195, 0.2);
      }
      .list {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        .subList,
        li {
          display: inline-block;
          max-width: 200px;
          height: 30px;
          line-height: 30px;
          background: rgba(@dateColor, 0.2);
          border-radius: 4px;
          padding: 0px 30px 0 10px;
          margin-right: 10px;
          margin-bottom: 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          position: relative;

          i {
            display: block;
            width: 11px;
            height: 11px;
            background: url("../../assets/img/evaluating/exit.png") no-repeat;
            background-size: 100%;
            position: absolute;
            right: 9px;
            top: 0px;
            bottom: 0px;
            margin: auto;
            cursor: pointer;
          }
        }
      }
    }
    ul {
      display: flex;
      color: @sub;
      font-size: 13px;
      margin-bottom: 10px;

      &:last-child {
        margin: 0px;
      }
      label {
        color: @green;
        font-weight: bold;
        min-width: 62px;
        height: 30px;
        line-height: 30px;
        margin-right: 20px;
        text-align: justify;
        word-break: keep-all;
        // white-space: nowrap;
        // text-align-last: justify;
        &.public {
          max-width: 62px;
        }

        &::after {
          content: "";
          display: inline-block;
          padding-left: 100%;
        }
      }
      li {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        flex: 1;
        span {
          min-width: 80px;
          padding: 0 8px;
          height: 30px;
          line-height: 30px;
          border-radius: 100px;
          margin-right: 10px;
          text-align: center;
          cursor: pointer;
          &.active {
            height: 28px;
            line-height: 28px;
            border: 1px solid @green;
            color: @green;
          }
        }
        &.btn {
          flex: 0 40px;
          justify-content: flex-end;

          button {
            border: 1px solid @dc;
            border-radius: 2px;
            width: 33px;
            height: 30px;
            font-size: 14px;
            color: @sub;
            background: none;
            margin-left: 8px;

            // &.down{
            //     width: 33px;
            //     margin: 0px;
            //     background: url('../../img/common/xiala.svg') no-repeat;
            //     background-position: center;
            // }
            &.setting {
              background: rgba(185, 195, 195, 0.2);
            }
            &:hover {
              .btnHover;
            }
            &:active {
              .btnActive;
            }
          }
        }
        &.showSelect {
          // height: auto;
          overflow-y: auto;
          margin-bottom: -10px;
          // max-height: 130px;
          // max-height: 80px;
          height: auto;
          span {
            margin-bottom: 10px;
          }
        }
        &::-webkit-scrollbar {
          width: 6px;
        }
        &::-webkit-scrollbar-thumb {
          background: #ddd;
          border-radius: 2px;
        }
      }
    }
  }
</style>